import * as React from 'react';
import Badge from 'react-bootstrap/Badge';
import Spinner from 'react-bootstrap/Spinner';
import { connect } from 'react-redux';
import { AppState } from '../../store';
import { fetchServerStatus } from '../../store/ServerStatus/actions';
import store from '../../store/store';

export interface ServerStatusProps {
    /** Custom class for wrapping component */
    wrapperClassName? : string;
    // status, msg, and loading are read from the shared Redux slice (store/ServerStatus).
    // The poller that fetches and updates these values is started once in App.tsx via startStatusPoller().
    status: string;
    msg: string;
    loading: boolean;
}

//gets display values from the API status string. This component is display-only
const getDisplayValues = (status: string, msg: string) => {
    if (status === 'Not Activated') return { iconColor: 'red', title: 'Not Activated', badge: 'close' };
    if (status === 'Disabled') return { iconColor: 'orange', title: msg, badge: 'warning' };
    if (status === 'Offline') return { iconColor: 'grey', title: 'Offline', badge: 'wifi_off' };
    if (status === 'Error') return { iconColor: 'yellow', title: 'Error Receiving Status', badge: 'close' };
    if (status === '') return { iconColor: 'red', title: 'Loading Status...', badge: 'close' };
    return { iconColor: 'green', title: 'Connected', badge: 'check' };
}

const ServerStatus: React.FunctionComponent<ServerStatusProps> = (props: ServerStatusProps) => {
    const { iconColor, title, badge } = getDisplayValues(props.status, props.msg);

    return (
        <div
        //click dispatches an immediate fetch outside the normal 60s polling cycle
        onClick={(e: React.SyntheticEvent) => {
            e.preventDefault();
            store.dispatch(fetchServerStatus() as any);
        }}
        className={`d-flex flex-row ${props.wrapperClassName}`}
        >
            <i id="server-status-icon" title={title} style={{ color : iconColor, fontSize: "25px"}} className="material-icons cursor-on-hover">dns</i>
            <Badge className="mt-auto d-flex justify-content-center align-items-center" pill variant="light" style={{marginLeft : "-12px", color : "#FFF", maxHeight : "18px", maxWidth : "18px"}}>
                <i
                    title={title}
                    className="material-icons mt-auto"
                    style={{fontSize : '10px', color : "black"}}
                >
                    {
                    props.loading
                    ? <Spinner className="server-status-spinner" as="span" role="status" animation="border" size="sm" />
                    : badge
                    }
                </i>
            </Badge>
        </div>
    );
}

ServerStatus.defaultProps = {
    wrapperClassName : "",
}

const mapStateToProps = (state: AppState) => ({
    status: state.serverStatus.status,
    msg: state.serverStatus.msg,
    loading: state.serverStatus.loading,
});

export default connect(mapStateToProps)(ServerStatus);
